import _              from 'lodash'
import React          from 'react'
import { withRouter } from 'react-router'
import { Alert      } from 'react-bootstrap'
import PropTypes      from 'prop-types'

import Validation                          from 'alto-react-components/lib/validation'
import { Panel, HorizontalForm           } from 'alto-react-components/lib/components'
import { passwordValidationSetting       } from 'alto-react-base-auth/lib/settings'
import { withAuthMessage                 } from 'alto-react-base-auth/lib/utils'
import { BadRequestError, ForbiddenError } from 'lib/errors'

class ChangePassword extends React.Component
  @contextTypes = { auth: PropTypes.object, settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    @state =
      passwordValidation: new Validation(passwordValidationSetting(context.settings))
      currentPassword: ''
      newPassword: ''
      passwordConfirmation: ''
      errors: {}

  render: ->
    <Panel id="change-password-panel" header="Změna hesla" bsStyle="info"
           className={@panelClassName()}>
      {@content()}
    </Panel>

  content: ->
    <div>
      {@alert()}
      {@form()}
    </div>

  panelClassName: ->
    'auth-panel'

  alert: ->
    <Alert bsStyle="danger">{@state.errors.detail}</Alert> if @state.errors?.detail

  form: ->
    <HorizontalForm>
      {@currentPasswordInput()}
      {@newPasswordInput()}
      {@confirmationInput()}
      {@submitButton()}
    </HorizontalForm>

  currentPasswordInput: ->
    if @context.auth.loggedInUser.hasPassword
      errors = @errorsFor('current_password')

      <HorizontalForm.Control autoFocus id='current-password' type="password"
       label='Stávající heslo'
       valid={@isCurrentPasswordValid()} help={errors}
       placeholder='Zadejte stávající heslo'
       value={@state.currentPassword}
       onChange={(value) => @setState(currentPassword: value, \
                                      errors: _.omit(@state.errors, 'current_password'))}
       onKeyPress={(e)   => @submit() if e.key == 'Enter' and @isValid()}
       {...@additionalCurrentPasswordProps()} />

  newPasswordInput: ->
    value  = @state.newPassword
    errors = if @isNewPasswordValid() then [] else @validatePassword(value)
    help   = errors.length and errors.map (error, index) -> <p key={index}>{error}</p>

    <HorizontalForm.Control id='new-password' type="password" label='Nové heslo'
     valid={!errors.length} help={help}
     placeholder='Zadejte nové heslo'
     value={value}
     onChange={(value) => @setState(newPassword: value, \
                                    errors: _.omit(@state.errors, 'new_password'))}
     onKeyPress={(e)   => @submit() if e.key == 'Enter' and @isValid()}
     {...@additionalNewPasswordProps()} />

  confirmationInput: ->
    value = @state.passwordConfirmation

    <HorizontalForm.Control id='password-confirmation' type="password" label='Ověření hesla'
     valid={@isPasswordConfirmed()}
     help={'Neshoduje se' unless @isPasswordConfirmed()}
     placeholder='Zadejte nové heslo ještě jednou'
     value={value}
     onChange={(value) => @setState(passwordConfirmation: value)}
     onKeyPress={(e)   => @submit() if e.key == 'Enter' and @isValid()}
     {...@additionalConfirmationPasswordProps()} />

  additionalCurrentPasswordProps:      -> {}
  additionalNewPasswordProps:          -> {}
  additionalConfirmationPasswordProps: -> {}

  submitButton: ->
    <HorizontalForm.Button id='change-password-submit' caption='Potvrdit' bsStyle="primary"
                           onClick={@submit.bind(@)} disabled={!@isValid()} />

  submit: ->
    @context.auth.changePassword(@state.currentPassword, @state.newPassword)
      .then (response) =>
        @props.history.push(withAuthMessage('/', 'password_change_successful', 'success'))
        null # otherwise runaway promise
      .catch BadRequestError, ForbiddenError, (error) =>
        @setState(errors: error.data)

  isValid: ->
    @isCurrentPasswordValid() and @isNewPasswordValid() and @isPasswordConfirmed()

  isCurrentPasswordValid: ->
    errors = @errorsFor('current_password')

    not @context.auth.loggedInUser.hasPassword or (@state.currentPassword.length and not errors?)

  isNewPasswordValid: ->
    not @validatePassword(@state.newPassword).length

  isPasswordConfirmed: ->
    @state.newPassword == @state.passwordConfirmation

  validatePassword: (password) ->
    backendErrors  = @state.errors['new_password'] or []
    frontendErrors = @state.passwordValidation.validate(password).map (message) =>
      'Heslo ' + message + '.'

    _.concat(backendErrors, frontendErrors)

  errorsFor: (fieldName) ->
    @state.errors[fieldName]?.join(' ')

export default withRouter(ChangePassword)
